import { Component, Input } from '@angular/core';
import { CardLinkAnalyticsService } from 'src/app/service/card-link-analytics.service';

@Component({
  selector: 'app-social-icons',
  templateUrl: './social-icons.component.html',
})
export class SocialIconsComponent {
  @Input() links: any[] = [];
  @Input() dir: string = '';
  @Input() showHideMultiLanguage: boolean = false;
  @Input() primaryThemeType: string = 'solid';
  @Input() primaryThemeColor: string = '#000000';
  @Input() primaryGradientColor: Record<string, string> = {};
  @Input() buttonTextColor: string = '#ffffff';
  @Input() primaryTextColor: string = '#000000';
  @Input() cardNo: string = '';
  @Input() TemplateName: string = '';

  constructor(private cardLinkAnalytics: CardLinkAnalyticsService) {}

  getGradientId(key: string, index?: number): string {
    return index !== undefined ? `${key}Gradient-${index}` : `${key}Gradient`;
  }

  /** Match ~2px stroke at 37px icon size for viewBox 128. */
  executiveProStrokeWidth(viewBoxSize: number): number {
    return viewBoxSize / 64;
  }

  /** Inset circle radius so stroke is not clipped at viewBox edges. */
  executiveProCircleRadius(center: number, viewBoxSize?: number): number {
    const stroke = viewBoxSize != null
      ? this.executiveProStrokeWidth(viewBoxSize)
      : 2;
    return center - stroke;
  }

  trackLinkClick(linkType: string, href: string, linkItem?: string): void {
    this.cardLinkAnalytics.trackLinkClick(this.cardNo, linkType, href, linkItem);
  }

  getSocialLabel(item: { type?: number; label?: string }): string {
    return this.cardLinkAnalytics.getSocialLabel(item);
  }
}

